<template>
  <form v-if="tagsHaveBeenPreloaded">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>{{ $t('Charities and Sponsors') }}</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="col-md-10 col-lg-8">
            <div class="panel panel-grey">
              <div class="panel-body">

                <template v-if="!$isNflClub">
                  <h3>Your Brand Partners</h3>
                  <tags type="sponsor" v-model="sponsorTags"/>
                  <div class="decorative-divider"></div>
                </template>

                <template>
                  <h3>{{$t('Your Charity Partners')}}</h3>
                  <tags type="charity" v-model="charityTags"/>
                </template>

              </div>
            </div>

            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleSaveTagsCallback">
              Save Changes
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tags from 'components/misc/Tags'
import { notify } from 'utils'
import { helpers } from 'mixins/profile'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  components: {
    Tags
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('talent/tag', ['tags']),

    charityTags: {
      get () {
        return this.tags.charity || []
      },

      set (tags) {
        this.replaceTags({ type: 'charity', tags })
      }
    },

    sponsorTags: {
      get () {
        return this.tags.sponsor || []
      },

      set (tags) {
        this.replaceTags({ type: 'sponsor', tags })
      }
    }
  },

  data () {
    return {
      tagsHaveBeenPreloaded: false
    }
  },

  created () {
    this.loadTags()
  },

  watch: {
    user: 'loadTags'
  },

  methods: {
    ...mapActions('talent/tag', ['getTalentTags', 'updateTalentTags', 'replaceTags']),

    /**
     * Handle saving tags against a user.
     *
     * @return Promise
     */
    handleSaveTagsCallback () {
      return this.updateTalentTags({
        id: this.user.id,
        payload: {
          tags: {
            charity: this.charityTags,
            sponsor: this.sponsorTags
          }
        }
      }).then(() => {
        notify.success('Successfully saved brand and charity partners.')
        this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.CHARITY_AND_SPONSORSHIP })
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  }
}
</script>
